const EVENT_PRODUCT_VIEW = 'event-product-view';
const productViewEventTrigger = () => {
  if (document.getElementById('product-sheet')) {
		const event = new CustomEvent(EVENT_PRODUCT_VIEW);
		document.dispatchEvent(event);
  }
};

export {EVENT_PRODUCT_VIEW, productViewEventTrigger};